import React from 'react';
import { Route, Switch } from 'react-router-dom';
import { newAppointmentTags, showAppointmentTags, editAppointmentTags } from '~/config/routes';
import List from './List';
import Edit from './Edit';
import Show from './Show';
import New from './New';
import { AppointmentTagsProvider } from './context';
import Can from '~/contexts/Can';
import NotPermissionPage from '~/pages/NotPermissionPage';

function AppointmentTags() {
  return (
    <AppointmentTagsProvider>
      <Switch>
        <Route
          exact
          path={newAppointmentTags.spec}
          render={(props) => (
            <>
              <Can I="new" a="AppointmentTags">
                {() => <New {...props} />}
              </Can>
              <Can not I="new" a="AppointmentTags">
                {() => <NotPermissionPage />}
              </Can>
            </>
          )}
        />
        <Route
          exact
          path={editAppointmentTags.spec}
          render={(props) => (
            <>
              <Can I="edit" a="AppointmentTags">
                {() => <Edit {...props} />}
              </Can>
              <Can not I="edit" a="AppointmentTags">
                {() => <NotPermissionPage />}
              </Can>
            </>
          )}
        />
        <Route
          exact
          path={showAppointmentTags.spec}
          render={(props) => (
            <>
              <Can I="show" a="AppointmentTags">
                {() => <Show {...props} />}
              </Can>
              <Can not I="show" a="AppointmentTags">
                {() => <NotPermissionPage />}
              </Can>
            </>
          )}
        />
        <Route
          render={(props) => (
            <>
              <Can I="list" a="AppointmentTags">
                {() => <List {...props} />}
              </Can>
              <Can not I="list" a="AppointmentTags">
                {() => <NotPermissionPage />}
              </Can>
            </>
          )}
        />
      </Switch>
    </AppointmentTagsProvider>
  );
}
export default AppointmentTags;
